export default __webpack_public_path__ + "5cd6f3c7133e95506783cb88684d978d.png";